var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShadowIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 109,
    viewBox: "0 0 176 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_72_10177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.185 70.7492C142.475 80.4575 114.612 81.1623 82.9524 72.3232C51.2925 63.4842 27.8244 48.4485 30.5348 38.7402C33.2453 29.0318 61.1079 28.3271 92.7678 37.1661C124.428 46.0052 147.896 61.0408 145.185 70.7492Z",
    fill: "#A2A2A2",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.185 70.7492C142.475 80.4575 114.612 81.1623 82.9524 72.3232C51.2925 63.4842 27.8244 48.4485 30.5348 38.7402C33.2453 29.0318 61.1079 28.3271 92.7678 37.1661C124.428 46.0052 147.896 61.0408 145.185 70.7492Z",
    fill: "#A2A2A2",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_72_10177",
    x: 0.321777,
    y: 0.97168,
    width: 175.077,
    height: 107.546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_72_10177"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIcon2);
export default __webpack_public_path__ + "static/media/ShadowIcon2.da5579d2cfb61eeedb1ebdddfc6eac32.svg";
export { ForwardRef as ReactComponent };